import { API_URL } from "@/config/constants";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import {
    IAllFieldSetsResponse,
    IFieldDefinitionResponse,
} from "./field-definitions.types";

const API = `${API_URL}/field-definitions`;

export const getFieldDefinitions = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const response = await axios.get<Page<IFieldDefinitionResponse>>(API, {
        params: { page, size, ...filter },
    });

    return response.data;
};

/**
 * Get all fieldsets with field definitions and properties (view-only).
 */
export const getAllFieldSets = async (): Promise<IAllFieldSetsResponse> => {
    const result = await axios.get<IAllFieldSetsResponse>(
        `${API_URL}/fieldsets`
    );
    return result.data;
};
